// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#informerNearestArrival .counter[data-v-4730daab]{font-size:.8rem;position:absolute;top:2px;left:15px;padding:3px}", ""]);
// Exports
module.exports = exports;
